<div
  class="input-container"
  data-testid="multi-select-dropdown-editor-container"
>
  <fieldset
    class="input-wrapper"
    tabindex="-1"
    (mousedown)="$event.stopPropagation()"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
  >
    <input
      #inputWithOptions
      type="text"
      readonly
      autocomplete="off"
      class="ag-input-field-input ag-text-field-input"
      [formControl]="searchControl"
      [placeholder]="placeholder"
      [style.width.px]="cellWidth"
      [style.height.px]="cellHeight"
      data-testid="multi-select-dropdown-editor-input"
      [matAutocomplete]="auto"
      (focus)="onFocus($event)"
      (click)="openPanel()"
      (keydown)="onKeydown($event)"
    />

    <mat-icon
      class="arrow-icon"
      role="button"
      tabindex="0"
      data-testid="multi-select-dropdown-arrow"
      (click)="togglePanel($event)"
      (keydown.enter)="togglePanel($event)"
    >
      {{ isPanelOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </mat-icon>

    <mat-autocomplete
      #auto="matAutocomplete"
      [panelWidth]="panelWidth"
      [class]="dropdownPanelClass"
      (opened)="onPanelOpen()"
      (closed)="onPanelClose()"
    >
      <div class="options-container">
        @if (loader()) {
        <mat-option
          class="loader-option"
          data-testid="multi-select-dropdown-loader"
        >
          <div class="center">
            <mat-spinner diameter="20"></mat-spinner>
          </div>
        </mat-option>
        } @if (!loader()) { @for (option of optionsToRender; track
        trackByOption($index, option)) {
        <mat-option
          class="multi-select-option"
          [class.selected-option]="isSelected(option)"
        >
          <div
            class="multi-select-option-content"
            tabindex="-1"
            (mousedown)="$event.preventDefault(); $event.stopPropagation()"
            (click)="onOptionRowClick(option, $event)"
            (keydown.enter)="onOptionRowClick(option, $event)"
          >
            <mat-checkbox
              class="multi-select-checkbox"
              color="primary"
              [checked]="isSelected(option)"
              (mousedown)="$event.preventDefault()"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              (change)="toggleOption(option, $event)"
            >
            </mat-checkbox>
            <div class="dropdown-option-label">
              {{ optionDisplayWith(option).primary }}
            </div>
          </div>
        </mat-option>
        } }
      </div>
    </mat-autocomplete>
  </fieldset>
</div>
